<template>
  <div class="card-expend-list">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-if="list.length" class="record-panel">
          <div
            v-for="(record, index) in list"
            :key="record.id || record.orderNo + '-' + index"
            class="record-item"
            @click="goOrderDetail(record)"
          >
            <div class="record-item__main">
              <div class="record-item__title">{{ record.orderNo }}</div>
              <div class="record-item__time">{{ record.createAt }}</div>
            </div>
            <div class="record-item__right">
              <div
                class="record-item__amount"
                :class="record.status === '1' ? 'amount-negative' : 'amount-positive'"
              >
                {{ formatAmount(record) }}
              </div>
              <van-icon name="arrow" class="record-item__arrow" />
            </div>
          </div>
        </div>

        <div v-if="!loading && !isLoading && list.length === 0" class="record-empty">
          <van-icon name="balance-o" size="2rem" color="#d8d8d8" />
          <p>暂无消费记录</p>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: 'CardExpendList',
  props: {
    cardId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      form: {
        cardId: '',
        current: 1,
        size: 20,
      },
    };
  },
  watch: {
    cardId: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.form.cardId = val;
        this.resetAndLoad();
      },
    },
  },
  methods: {
    getPointUnit(item) {
      if (item && item.ticketType === 'E3' && item.upgradeFlag === 'C1') {
        return '票';
      }
      return '点';
    },
    formatAmount(item) {
      const unit = this.getPointUnit(item);
      const prefix = item.status === '1' ? '-' : '+';
      return `${prefix}${item.cardPoints}${unit}`;
    },
    goOrderDetail(record) {
      if (!record?.orderNo) return;
      const path = String(record.productType) === '2' ? '/OrderDetail' : '/CakaOrderDetail';
      this.$router.push({ path, query: { orderNo: record.orderNo } });
    },
    resetAndLoad() {
      this.form.current = 1;
      this.finished = false;
      this.list = [];
      this.loadRecords();
    },
    onRefresh() {
      this.form.current = 1;
      this.finished = false;
      this.list = [];
      this.loadRecords();
    },
    onLoad() {
      if (this.list.length > 0) {
        this.form.current += 1;
        this.loadRecords();
      }
    },
    loadRecords() {
      if (!this.form.cardId) {
        this.loading = false;
        this.isLoading = false;
        this.finished = true;
        return;
      }
      this.loading = true;
      this.$api
        .queryCardExpendByCardId(this.form)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
            this.finished = true;
            return;
          }
          const records = res.data.records || [];
          if (this.form.current === 1) {
            this.list = records;
          } else {
            this.list.push(...records);
          }
          this.finished = this.form.current >= res.data.pages;
        })
        .catch(() => {
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.record-panel {
  width: 100%;
  background: #fff;
  border-radius: 0.875rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.record-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:active {
    background: #fafafa;
  }
}

.record-item__main {
  flex: 1;
  min-width: 0;
}

.record-item__title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  word-break: break-all;

  &::before {
    content: '订单号：';
    color: #888;
    font-weight: 400;
  }
}

.record-item__time {
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: #999;
}

.record-item__right {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}

.record-item__amount {
  min-width: 4rem;
  text-align: right;
  font-size: 0.9375rem;
  font-weight: 600;
}

.record-item__arrow {
  color: #ccc;
  font-size: 0.875rem;
}

.amount-negative {
  color: #ee0a24;
}

.amount-positive {
  color: #07c160;
}

.record-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2.5rem 1rem;
  background: #fff;
  border-radius: 0.875rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  color: #999;
  font-size: 0.875rem;
  box-sizing: border-box;

  p {
    margin: 0.5rem 0 0;
  }
}
</style>
